import React, { Component } from "react";
import logo from "../../../assets/images/branding/logo-blue.svg";
import FullPageLayout from "../../shared/components/layouts/FullPageLayout";

export class UniversalPage extends Component {
  render() {
    return (
      <FullPageLayout gridClassName="--narrow _marginTop--80px _paddingX--16px-mobileOnly">
        <img src={logo} className="_width--122px" alt="Logo" />

        <h2 className="_fontSize--32px-desktopOnly _fontSize--xlarge-mobileOnly _marginTop--40px-desktopOnly _marginTop--56px-mobileOnly" style={{ color: "#003A70" }}>
          We've upgraded our platform!
        </h2>

        <p className="_fontSize--16px-desktopOnly _marginTop--large" style={{ color: "#586069" }}>
          Our old platform is no longer available. Don’t worry— your account, data, and funds are all safe.
        </p>

        <p className="_fontSize--16px-desktopOnly _marginTop--large" style={{ color: "#586069" }}>
          You can now use our new and improved platform by logging in with your usual email and password.
        </p>

        <p className="_fontSize--16px-desktopOnly _marginTop--large" style={{ color: "#586069" }}>
          If you have any questions or need assistance, don’t hesitate to reach out to your Account Manager, or email <span style={{ fontWeight: "bold" }}>
            <a href="mailto:support@firstcircle.com" style={{ textDecoration: "underline", color: "#586069", fontFamily: "Lota Grotesque Regular", fontWeight: "normal" }}>
              support@firstcircle.com
            </a>
          </span>
        </p>

        <div className="_marginTop--40px _width--full-mobileOnly">
          <a
            href="https://account.firstcircle.ph"
            className="_centered _loginScreenButton-desktopOnly _loginScreenButton-mobileOnly"
          >
            Explore the new platform
          </a>
        </div>
      </FullPageLayout>
    );
  }
}


export default UniversalPage;



// WEBPACK FOOTER //
// ./src/features/home/containers/UniversalPage.js